// src/pages/NeuerKundePage.jsx
import { useState } from "react";
import {
    Box,
    Heading,
    Input,
    Button,
    VStack,
    Grid,
    GridItem,
} from "@chakra-ui/react";
import axios from "axios";
import { Textarea } from "@chakra-ui/react";

export default function NeuerKundePage() {

    const [showAnsrpecbpartner, setAnsrpecbpartner] = useState(false);

    const [kunde, setKunde] = useState({
        firma: "",
        anrede: "",
        vorname: "",
        nachname: "",
        strasse: "",
        plzOrt: "",
        telefon: "",
        mobil: "",
        email: "",
        hinweis: "",
        ansprechpartnerVorname: "",
        ansprechpartnerNachname: "",
        ansprechpartnerTelefon: "",
        ansprechpartnerMobil: "",
        ansprechpartnerEmail: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setKunde((prev) => ({ ...prev, [name]: value }));
    };


    return (
        <Box maxW="4xl" mx="auto" mt={10} p={8} bg="white" borderRadius="xl" boxShadow="lg">
            <Heading size="md" mb={6}>
                Neuen Kunden anlegen
            </Heading>

            <VStack spacing={5} align="stretch">
                <Input name="firma" placeholder="Firma" value={kunde.firma} onChange={handleChange} />

                <select
                    name="anrede"
                    value={kunde.anrede}
                    onChange={handleChange}
                    style={{ padding: "10px", borderRadius: "8px", border: "1px solid #ccc" }}
                >
                    <option value="">Anrede wählen</option>
                    <option value="Herr">Herr</option>
                    <option value="Frau">Frau</option>
                </select>

                <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={4}>
                    <GridItem>
                        <Input name="vorname" placeholder="Vorname" value={kunde.vorname} onChange={handleChange} />
                    </GridItem>
                    <GridItem>
                        <Input name="nachname" placeholder="Nachname" value={kunde.nachname} onChange={handleChange} />
                    </GridItem>
                </Grid>

                <Grid templateColumns={{ base: "1fr", md: "2fr 1fr" }} gap={4}>
                    <GridItem>
                        <Input name="strasse" placeholder="Straße / Hausnummer" value={kunde.strasse} onChange={handleChange} />
                    </GridItem>
                    <GridItem>
                        <Input name="plzOrt" placeholder="PLZ / Ort" value={kunde.plzOrt} onChange={handleChange} />
                    </GridItem>
                </Grid>

                <Heading size="sm" mt={4} color="blue.500">
                    Kunden-Kontakt
                </Heading>
                <Input name="telefon" placeholder="Telefon" value={kunde.telefon} onChange={handleChange} />
                <Input name="mobil" placeholder="Mobil" value={kunde.mobil} onChange={handleChange} />
                <Input name="email" placeholder="Email" type="email" value={kunde.email} onChange={handleChange} />



                <Box mb={5} mt={4}>
                    <Button
                        onClick={() => setAnsrpecbpartner(!showAnsrpecbpartner)}
                        bg="#B8860B"
                        color="white"
                        size="md"
                        _hover={{ bg: "#9A7209" }}
                        borderRadius="lg"
                    >
                        {showAnsrpecbpartner ? "Ansprechpartner-Kontakt minimieren" : "Ansprechpartner-Kontakt anzeigen"}
                    </Button>
                </Box>


                {showAnsrpecbpartner && (
                    <>
                        <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={4}>
                            <GridItem>
                                <Input name="ansprechpartnerVorname" placeholder="Vorname" value={kunde.ansprechpartnerVorname} onChange={handleChange} />
                            </GridItem>
                            <GridItem>
                                <Input name="ansprechpartnerNachname" placeholder="Nachname" value={kunde.ansprechpartnerNachname} onChange={handleChange} />
                            </GridItem>
                        </Grid>

                        <Input name="ansprechpartnerTelefon" placeholder="Telefon" value={kunde.ansprechpartnerTelefon} onChange={handleChange} />
                        <Input name="ansprechpartnerMobil" placeholder="Mobil" value={kunde.ansprechpartnerMobil} onChange={handleChange} />
                        <Input name="ansprechpartnerEmail" placeholder="Email" value={kunde.ansprechpartnerEmail} onChange={handleChange} />

                    </>
                )}


                <Textarea
                    name="hinweis"
                    placeholder="Hinweis"
                    value={kunde.hinweis}
                    onChange={handleChange}
                    mb={3}
                />

                <Button
                    bg="#B8860B"
                    color="white"
                    _hover={{ bg: "#9A7209" }}
                    alignSelf="flex-start"
                    mt={3}
                    onClick={async () => {
                        try {
                            await axios.post(`${process.env.REACT_APP_API_URL}/api/kunden`, kunde);
                            alert("Kunde erfolgreich angelegt!");
                        } catch (error) {
                            alert("Fehler beim Anlegen des Kunden");
                            console.error(error);
                        }
                    }}
                >
                    Erstellen
                </Button>
            </VStack>
        </Box>
    );
}